import { resolveComponent as n, openBlock as e, createElementBlock as a, normalizeClass as c, createBlock as l, createCommentVNode as s, renderSlot as m } from "vue";
import { _ as d } from "./_plugin-vue_export-helper-dad06003.js";
import { P as i } from "./PreloaderIcon-b44be854.js";
const p = {
  name: "ButtonPrimaryErrorLg",
  components: {
    PreloaderIcon: i
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  }
};
function f(r, u, o, _, g, B) {
  const t = n("PreloaderIcon");
  return e(), a("button", {
    type: "button",
    class: c(["ct-btn-error-1 ct-btn-lg", { "is-loading": o.loading }])
  }, [
    o.loading ? (e(), l(t, { key: 0 })) : s("", !0),
    m(r.$slots, "default")
  ], 2);
}
const k = /* @__PURE__ */ d(p, [["render", f]]);
export {
  k as B
};
